import { createSlice, PayloadAction } from '@reduxjs/toolkit'
export interface showListI {
  workId: string
  workName: string
  authorName: string
  dynasty: string
  museum: string
  src: string
}
interface likesPageListI {
  pageTotal: number //总收藏数
  nowPage: number //当前页数
  idList: string[] //上一次浏览id列表
  showList: showListI[] //上一次浏览列表
}

const initialState: likesPageListI = {
  pageTotal: 0,
  nowPage: 1,
  idList: [],
  showList: []
}

export const setLikesPageListSlice = createSlice({
  name: 'setLikesPageList',
  initialState,
  reducers: {
    setLikesTotal: (state, action: PayloadAction<number>) => {
      state.pageTotal = action.payload
    },
    setLikesNowPage: (state, action: PayloadAction<number>) => {
      state.nowPage = action.payload
    },
    setIdList: (state, action: PayloadAction<string[]>) => {
      state.idList = action.payload
    },
    setLikesShowList: (state, action: PayloadAction<showListI[]>) => {
      state.showList = action.payload
    }
  }
})
export const { setLikesTotal, setLikesShowList, setLikesNowPage, setIdList } =
  setLikesPageListSlice.actions
export default setLikesPageListSlice.reducer
